/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_DeductedInputs */

const en_cargos_deducted = /** @type {(inputs: Cargos_DeductedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deducted`)
};

const es_cargos_deducted = /** @type {(inputs: Cargos_DeductedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deducido`)
};

/**
* | output |
* | --- |
* | "Deducted" |
*
* @param {Cargos_DeductedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_deducted = /** @type {((inputs?: Cargos_DeductedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_DeductedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_deducted(inputs)
	return es_cargos_deducted(inputs)
});